<template>
    <div :id="`${type}-campaigns`" class="slider-container">
        <div class="d-flex justify-content-between">
            <div 
                data-name="swiper-slider-header" 
                :class="{'pb-4': campaigns.length <= 3}"
                >
                <p>{{title}}</p>
            </div>
            <div 
                class="col-6 align-items-center justify-content-end" 
                :class="{
                    threeCards: campaigns.length === 3,
                    'd-none': campaigns.length < 3,
                    'd-flex': campaigns.length > 3
                }">
                <div :id="`${type}-previous`" class="swiper-button swiper-button-prev" :class="`${this.type}-swiper-button-prev`" slot="button-prev">
                    <Icon id="mb-previous-arrow-landing" icon="landing-slider-prev" class="swiper-button landing-slider-button-prev"/>
                </div>
                <div :id="`${type}-next`" class="swiper-button swiper-button-next" :class="`${this.type}-swiper-button-next`" slot="button-next">
                    <Icon id="mb-next-arrow-landing" icon="landing-slider-prev" class="swiper-button landing-slider-button-next"/>
                </div>
            </div>
        </div>
        <div class="row slider-row">
            <div class="col-12 slider-col">
                <swiper class="swiper" :ref="`${type}-swiper`" :options="swiperOption" style="padding-bottom: 50px; padding-top: 20px">
                    <swiper-slide 
                        v-for="(camp, index) in campaigns" 
                        :key="'card'+index">
                            <Card :campaign="camp" :id="`${type}-cards-${index}`" list="real" :type="type"/>
                    </swiper-slide>
                </swiper>
            </div>
        </div>
    </div>
</template>

<script>
    import Card from "./Card";
    import Icon from "../Theme/Icon";
    export default {
        name: "SwiperSlider",
        props: {
            title: String,
            sliderId: String,
            type: String,
            campaigns: Array
        },
        computed: {
            swiper() {  
                return this.$refs[this.type+'-swiper'].swiper;  
            },
            swiperOption() {
                return {
                    loop: this.campaigns.length > 3,
                    slidesPerView: 3,
                    spaceBetween: 40,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false
                    },
                    navigation: {
                        nextEl: `.${this.type}-swiper-button-next`,
                        prevEl: `.${this.type}-swiper-button-prev`,
                    },
                    breakpoints: {
                        1124: {
                            slidesPerView: 2,
                            spaceBetween: 10
                        },
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 30
                        }
                    }
                }
            },
        },
        components: {
            Icon,
            Card,
        },
    };
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.slider-container {
    div[data-name="swiper-slider-header"] {
        p {
            color: $c6;
            font-size: $h4;
            font-weight: $weight_bold;
            margin-bottom: 0;
        }
    }

    .threeCards {
        display: none!important;
        @media screen and (max-width: 1124px) {
            display: flex!important;
        }
    }
    .swiper-button {
        outline: none;
        &:last-child {
            img {
                transform: rotate(180deg);
                margin-left: 24px;
            }
        }
        img {
            cursor: pointer;
            &:focus {
                outline: none;
                border: none;
            }
        }
    }
}
// @media (max-height: 721px){
//     .slider-row {
//         max-height: 300px;
//         .slider-col {
//             transform: scale(0.6);
//             margin-top: -106px;
//         }
//     }   
// }
</style>